export function setItems(state, payload) {
  state.items = payload;
}

export function setIsLoading(state, payload) {
  state.isLoading = payload;
}

export function setActiveSubMenuName(state, payload) {
  state.activeSubMenuName = payload;
}
